import {Pipe, PipeTransform} from '@angular/core';
import {TransferDto} from '../../../Models/Warehouse/Transfers/transfer.interface';

@Pipe({
  name: 'transfers',
  standalone: false
})
export class TransfersPipe implements PipeTransform {

  transform(items: TransferDto[], filter: { localOrigin?: number, localDestination?: number, status?: number }): TransferDto[] {

    if (!items.length) {
      return [];
    }

    if (filter.localOrigin) {
      items = items.filter((item) => item.id_local === filter.localOrigin);
    }

    if (filter.localDestination) {
      items = items.filter((item) => item.id_local_destino === filter.localDestination);
    }

    if (filter.status) {
      items = items.filter((item) => item.id_estado === filter.status);
    }

    return items;

  }

}
